import { Product } from "~/common/props/orchestrator";
import { getDomain } from "@commons-monorepo/index";
import { ReviewItem } from "~/components/Reviews/reviews.types";
import { useOutletContext } from "@remix-run/react";

type SchemaProps = {
  product: Product;
  productId?: string;
  reviews: ReviewItem[];
};

const SchemaGraph = ({ product, productId, reviews }: SchemaProps) => {
  const { storeMetadata } = useOutletContext<any>();
  const partnerUrl = storeMetadata?.userNetwork?.urlSummer;
  const imgDefault = product?.images && product?.images[0];
  const currency = storeMetadata?.currency;
  const url = `${getDomain()}/`;
  const averageRating =
    reviews.reduce((a, b) => a + b.stars, 0) / reviews.length || 0;

  return (
    <>
      <script
        type='application/ld+json'
        className='yoast-schema-graph'
        dangerouslySetInnerHTML={{
          __html: `
                    {
                        "@context":"https://schema.org",
                        "@type": "Product",
                        "@id":"${product.id}",
                        "image": "${imgDefault}",
                        "name": "${product.name?.replace(/['"]+/g, "'")}",
                        "description":"${product?.description?.replace(
                          /['"]+/g,
                          "'",
                        )}",
                        "brand":{
                            "@type": "Brand",
                            "name": "${storeMetadata?.enterpriseName}"
                        },
                        "sku": "smr-${product.id}",
                        ${
                          reviews?.length > 0
                            ? `
                            "review": [${reviews.map(
                              (review) => `
                                    {
                                        "@type": "Review",
                                        "reviewRating": {
                                            "@type": "Rating",
                                            "ratingValue": "${review.stars}"
                                        },
                                        "author": {
                                            "@type": "Person",
                                            "name": ${
                                              !!review.author
                                                ? review.author
                                                : "Comprador"
                                            }
                                        }
                                    }
                                `,
                            )}],
                            "aggregateRating": {
                                "@type": "AggregateRating",
                                "ratingValue": "${averageRating}",
                                "reviewCount": "${reviews?.length}"
                            },
                        `
                            : ""
                        }
                        "offers": {
                            "@type": "Offer",
                            "priceCurrency": "${currency}",
                            "price": "${product.price}",
                            "availability": "https://schema.org/InStock",
                            "url": "${url}catalogo/${partnerUrl}/producto/${productId}"
                        }
                    }
				`,
        }}
      />
      <script
        type='application/ld+json'
        className='yoast-schema-graph'
        dangerouslySetInnerHTML={{
          __html: `
					{
						"@context": "https://schema.org",
						"@type": "BreadcrumbList",
						"itemListElement": [
                            {
                                "@type": "ListItem",
                                "position": 1,
                                "name": "Inicio",
                                "item": "${url}catalogo/${partnerUrl}"
                            },
                            {
                                "@type": "ListItem",
                                "position": 2,
                                "name":"${product.category}",
                                "item": "${url}catalogo/${partnerUrl}/producto/${productId}"
                            }
						]
					}
				`,
        }}
      />
    </>
  );
};

export default SchemaGraph;
